import TakeBackupComponent from '../Components/Backup/TakeBackupComponent';

/**
 * Business Support > Take Backup. The component owns both tabs (the backup list and the DB
 * configuration), so this wrapper stays a one-liner like the other admin pages.
 */
function TakeBackupPage() {
  return <TakeBackupComponent />;
}

export default TakeBackupPage;
